import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField, NullableInput} from "../../Shared/InputField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const MeterForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [CategoryOptions, setCategoryOptions] = useState([])
    const [locationOptions, setLocationOptions] = useState([])

    const [formData, setFormData] = useState({
        serial_number: "",
        initial_reading: "",
        lock_number: null,
        remark: null,
        category_id: "",
        location_id: "",
    })
    const {serial_number, initial_reading, lock_number, remark, category_id, location_id} = formData

    const navigate = useNavigate()

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const meterData = {location_id, serial_number, initial_reading, lock_number, remark, category_id}
        addMeter(meterData)
    }
    
    // add meter
    const addMeter = async (meterData) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/meters/', meterData)
            if (response.status === 201){
                toast.success('Successfully created')
                navigate('/meters-serverside')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

    // Load options dynamically from a remote source
    const loadOptions = async (url, query, setOptions) => {
        const params = { q: query };

        try {
            const response = await Server.get(`/options/${url}`, {params});
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Create New Meter</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <AsyncSelectField
                                name="location_id"
                                label="Location"
                                value={location_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('locations', query, setLocationOptions)}
                                options={locationOptions}
                                placeholder="Start typing to search..."
                                error={errors.location_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Meter Serial Number (Optional)"
                                name="serial_number"
                                type="text"
                                label="Serial Number"
                                value={serial_number}
                                onChange={onChange}
                                error={errors.serial_number}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Meter Current Reading"
                                name="initial_reading"
                                type="number"
                                label="Initial Reading"
                                value={initial_reading}
                                onChange={onChange}
                                error={errors.initial_reading}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <NullableInput
                                placeholder="Box Lock Number (Optional)"
                                name="lock_number"
                                type="text"
                                label="Lock Number"
                                value={lock_number}
                                onChange={onChange}
                                error={errors.lock_number}
                            />
                        </div>
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="category_id"
                                label="Category"
                                value={category_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('meter-categories', query, setCategoryOptions)}
                                options={CategoryOptions}
                                placeholder="Start typing to search..."
                                error={errors.category_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <NullableInput
                                placeholder="Meter Remarks (Optional)"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Meter" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default MeterForm
